"use strict";

var Prompt = require("app/shared/components/Prompt/prompt");
var teamsAPI = require("app/util/api/team");
var SignalActions = require("app/shared/actions/signal-actions");
var Intl = require("intl");

var ERROR_MESSAGE_TIME = 5000;

var TeamConfirmConsolidatePrompt = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    isOpen: React.PropTypes.bool,
    onClose: React.PropTypes.func,
    handleSynchronizationWarning: React.PropTypes.func
  },
  getInitialState: function() {
    return {
      isSaving: false
    };
  },
  handleConfirm: function() {
    this.disableSaveButton();
    this.synchronizeTeams();
  },
  synchronizeTeams: function() {
    teamsAPI.createSync(this.handleSynchronizeTeamsSuccess, this.handleRequestError);
    this.props.handleSynchronizationWarning(false);
  },
  handleSynchronizeTeamsSuccess: function() {
    window.location.reload();
  },
  handleRequestError: function(body) {
    if(body.length != 0) {
      SignalActions.show({
        message: "Não foi possível sincronizar equipes.",
        type: "warning",
        hideTimeout: ERROR_MESSAGE_TIME
      });
    }
  },
  handleConfirmError: function(error, response) {
    var errorMessage = teamsAPI.getTeamErrorMessage(error, response);
    SignalActions.show({
      message: errorMessage,
      type: "warning",
      hideTimeout: ERROR_MESSAGE_TIME
    });
    this.enableSaveButton();
  },
  handleClose: function() {
    window.location.reload();
    this.props.onClose();
  },
  disableSaveButton: function() {
    this.setState({
      isSaving: true
    })
  },
  enableSaveButton: function() {
    this.setState({
      isSaving: false
    })
  },
  getConfirmButtonText: function(){
    return this.state.isSaving ? "Iniciando atualização..." : "Concluir e iniciar atualização";
  },
  render: function(){
    var promptProps = {
      title: "Concluir alterações de equipes?",
      hideWarningIcon: false,
      buttonText: this.getConfirmButtonText(),
      cancelText: "Não, continuar editando",
      buttonClasses: "btn btn-primary",
      isOpen: this.props.isOpen,
      onClose: this.handleClose,
      autoClose: false,
      onConfirm: this.handleConfirm,
      onCancel: this.handleClose,
      disabledConfirmButton: this.state.isSaving
    };

    return (
      <Prompt {...promptProps} type="confirm">
        <div className="w-700 maxw-550"> 
          <PromptSubtitle />
        </div>
      </Prompt>
    );
  }
});

const PromptSubtitle = () => (
  <div className="mt-20 minw-300 ta-c">
    <span className="d-ib mb-30">
      As empresas, pessoas e negócios que já existem serão atualizadas e isso pode levar alguns minutos.
    </span>
    <br/>
    <span className="d-ib mb-30">
      <b>Novas alterações de equipes ficarão bloqueadas</b> até o processo finalizar.
    </span>
    <a 
      href="https://ajuda.agendor.com.br/pt-BR/articles/8448796-por-que-preciso-atualizar-os-dados-apos-alterar-uma-equipe" 
      target="_blank">Saiba mais
    </a>
  </div>
);

module.exports = TeamConfirmConsolidatePrompt;



// WEBPACK FOOTER //
// ./app/shared/components/TeamSelector/team-confirm-consolidate-prompt.jsx